module.exports = __webpack_public_path__ + "img/hamburger_menu.b0c8b648.svg";